import type { DTO } from "@equidefi/shared/types";
import { type FC, type PropsWithChildren, createContext, useMemo } from "react";
import { useGetVault } from "../hooks/useVault";

type VaultContextType = {
  vaultId?: string | null;
  vault: DTO.Vault | null;
  refetch: () => Promise<unknown>;
};

type InvestmentProps = {
  vault_id: string | null;
};

type VaultProviderProps = {
  investment: InvestmentProps;
};

export const VaultContext = createContext<VaultContextType>({
  vaultId: null,
  vault: null,
  refetch: async () => {},
});

const VaultProvider: FC<PropsWithChildren<VaultProviderProps>> = ({ children, investment }) => {
  const vaultId = useMemo<string | null>(() => investment?.vault_id, [investment?.vault_id]);
  const { data: vault, refetch } = useGetVault(vaultId, {
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return (
    <VaultContext.Provider
      value={{
        vaultId,
        vault,
        refetch,
      }}>
      {children}
    </VaultContext.Provider>
  );
};

export default VaultProvider;
